import { useEffect, useRef } from "react";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { useNotificationStore } from "../Zustand/notification.store";
import { BrowserAuthError } from "@azure/msal-browser";
import {
  buildLoginRequest,
  clearLoginRetryState,
  hasRetriedTenantError,
  isWrongTenantError,
  markForceAccountPicker,
  markTenantErrorRetried,
} from "../auth/loginHelpers";

export default function CustomLoginCallback() {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const showNotification = useNotificationStore((s) => s.show);
  const hasHandled = useRef(false);

  useEffect(() => {
    if (hasHandled.current) {
      return;
    }

    const handleRedirect = async () => {
      hasHandled.current = true;

      try {
        const response = await instance.handleRedirectPromise();

        if (response || instance.getAllAccounts().length > 0) {
          clearLoginRetryState();
          navigate("/home", { replace: true });
          return;
        }

        navigate("/login", { replace: true });
      } catch (err: any) {
        console.error("MSAL: callback error", err);

        if (
          err instanceof BrowserAuthError &&
          err.errorCode === "interaction_in_progress"
        ) {
          sessionStorage.clear();
          window.location.href = "/login";
          return;
        }

        if (isWrongTenantError(err) && !hasRetriedTenantError()) {
          markTenantErrorRetried();
          markForceAccountPicker();
          await instance.loginRedirect(
            buildLoginRequest({ forceAccountPicker: true })
          );
          return;
        }

        if (isWrongTenantError(err)) {
          markForceAccountPicker();
          navigate("/login", { replace: true });
          return;
        }

        showNotification(String(err?.message || "Login failed"), "error");
        navigate("/login", { replace: true });
      }
    };

    handleRedirect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div>Signing you in…</div>;
}
